import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/loader";
import {
  fetchBookingList,
  fetchBusinessBooking,
  fetchUserBooking,
} from "../../redux/adminReducer";
import { IoEyeOutline } from "react-icons/io5";
function Booking({ userId, salonId, role }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { translations, dir } = useSelector((state) => state.language);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("all");
  const itemsPerPage = 10;
  const dispatch = useDispatch();
  const [bookingData, setBookingData] = useState([]);
  const [totalBookingCount, setTotalBookingCount] = useState(0);

  const fetchBookings = async (b) => {
    try {
      setLoading(true);
      if (role === "user") {
        const b = {
          userId,
          currentPage,
          filter,
        };
        const res = await dispatch(fetchUserBooking(b)).unwrap();
        setBookingData(res.data);
        setTotalBookingCount(res.pagination.total);
      } else if (role === "salon") {
        const b = {
          salonId,
          currentPage,
          filter,
        };
        const res = await dispatch(fetchBusinessBooking(b)).unwrap();
        setBookingData(res.data);
        setTotalBookingCount(res.pagination.total);
      } else {
        const b = {
          currentPage,
          filter,
        };
        const res = await dispatch(fetchBookingList(b)).unwrap();
        setBookingData(res.bookings);
        setTotalBookingCount(res.totalBookings);
      }
    } catch (error) {
      console.error("Error fetching rides:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const b = {
      currentPage,
      filter,
    };
    fetchBookings(b);
  }, [dispatch, currentPage, filter, role, userId, salonId]);

  const [error, setError] = useState("");
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);

    if (selectedPage > totalPages) {
      setError(`Maximum value must be ${totalPages}`);
      // setCurrentPage(totalPages);
      return;
    }
    setCurrentPage(selectedPage);
    setError("");
  };
  const totalPages = Math.ceil(totalBookingCount / itemsPerPage);

  const handleRowClick = (bookingId) => {
    navigate(`/booking/booking-details/${bookingId}`);
  };

  const BookingContent = (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl font-semibold text-white">
              {translations.booking.bookingList}
            </h2>
            <div className="flex items-center">
              <label htmlFor="salon-status" className="text-white px-2">
                {translations.booking.filter} :
              </label>
              <div className="relative">
                <select
                  id="salon-status"
                  className="bg-gray-700 text-white rounded ps-2 pe-5 py-2 focus:outline-none w-full appearance-none"
                  value={filter}
                  onChange={(e) => {
                    const value =
                      e.target.value === "all" ? "all" : Number(e.target.value);
                    setFilter(value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="all">{translations.booking.all}</option>
                  <option value="200">{translations.booking.pending}</option>
                  <option value="201">{translations.booking.confirmed}</option>
                  <option value="202">
                    {translations.booking.rescheduled}
                  </option>
                  <option value="203">{translations.booking.cancelled}</option>
                  <option value="204">{translations.booking.completed}</option>
                  <option value="205">{translations.booking.noShow}</option>
                </select>

                <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          {bookingData?.length === 0 ? (
            <div className="flex h-64 items-center justify-center text-gray-500 dark:text-gray-400">
              <p className="text-xl">{translations.booking.noData}</p>
            </div>
          ) : (
            <>
              <div className="grid  md:grid lg:grid  overflow-x-auto ">
                <table className="min-w-full text-white shadow-md   p-2">
                  <thead className="bg-[#5A189A] text-white text-md text-center">
                    <tr>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.userName}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.salonName}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.staffName}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.bookingDate}
                      </th>

                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.duration}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.status}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.timing}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.userPhone}
                      </th>
                      {role !== "user" && role !== "salon" && (
                        <th className=" px-3 py-3 whitespace-nowrap">
                          {translations.booking.actions}
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-600 ">
                    {bookingData?.map((booking, index) => (
                      <tr key={index} className="transition  text-center mb-3">
                        <td className="px-3 py-3">{booking.user_id.name}</td>
                        <td className="px-3 py-3">
                          {booking.salon_id.business_name}
                        </td>
                        <td className="px-3 py-3">{booking.staff_id.name}</td>
                        <td className="px-3 py-3">{booking.booking_date}</td>
                        <td className="px-3 py-3">
                          {booking.total_duration} mins
                        </td>
                        <td className="px-3 py-3">
                          <span
                            className={`px-3 py-1 rounded-full text-sm font-semibold
                                        ${
                                          booking.status === 200
                                            ? "bg-yellow-200 text-yellow-700"
                                            : booking.status === 201
                                            ? "bg-blue-200 text-blue-700"
                                            : booking.status === 202
                                            ? "bg-purple-200 text-purple-700"
                                            : booking.status === 203
                                            ? "bg-red-200 text-red-700"
                                            : booking.status === 204
                                            ? "bg-green-200 text-green-700"
                                            : booking.status === 205
                                            ? "bg-gray-200 text-gray-700"
                                            : ""
                                        }`}
                          >
                            {booking.status === 200
                              ? translations.booking.pending
                              : booking.status === 201
                              ? translations.booking.confirmed
                              : booking.status === 202
                              ? translations.booking.rescheduled
                              : booking.status === 203
                              ? translations.booking.cancelled
                              : booking.status === 204
                              ? translations.booking.completed
                              : translations.booking.noShow}
                          </span>
                        </td>
                        <td className="px-3 py-3">
                          {booking.start_time}-{booking.end_time}
                        </td>
                        <td
                          className="px-3 py-3  whitespace-nowrap"
                          style={{ direction: "ltr" }}
                        >
                          {booking.user_id.fullPhoneNumber}
                        </td>

                        {role !== "user" && role !== "salon" && (
                          <td className="px-4 py-5 flex ">
                            <button
                              className="hover:text-green-600  text-2xl"
                              onClick={() => handleRowClick(booking._id)}
                            >
                              <IoEyeOutline />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Pagination Controls */}
              <div className="mt-4 flex justify-between text-white">
                <svg
                  className={`${
                    currentPage === 1
                      ? "fill-current"
                      : "cursor-pointer fill-current"
                  }
                        ${dir === "rtl" && "rotate-180"}`}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  width={24}
                  height={24}
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  aria-disabled={currentPage === 1}
                >
                  <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                </svg>
                <span>
                  {translations.booking.page}
                  {totalPages > 1 ? (
                    <input
                      type="number"
                      name=""
                      id="pagination-jump"
                      className={
                        error
                          ? `mx-2 rounded-md border  ps-1 border-red  bg-gray-800 text-white shadow-card focus:border-primary`
                          : `mx-2 rounded-md border border-gray-300 ps-1  bg-gray-800 text-white shadow-card focus:border-primary`
                      }
                      min={1}
                      max={totalPages}
                      defaultValue={currentPage}
                      onChange={(e) => e.target.value}
                      onBlur={(e) => handlePageChange(e)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handlePageChange(e);
                        }
                      }}
                    />
                  ) : (
                    <span className="mx-1">{currentPage}</span>
                  )}
                  {translations.booking.of} {totalPages}
                </span>
                <svg
                  className={`${
                    currentPage === totalPages
                      ? "fill-current"
                      : "cursor-pointer fill-current"
                  }
                        ${dir === "rtl" && "rotate-180"}`}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 320 512"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  aria-disabled={currentPage === totalPages}
                >
                  <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                </svg>
              </div>
            </>
          )}
        </>
      )}
    </>
  );

  return role ? (
    BookingContent
  ) : (
    <Layout>
      <div className="min-h-screen w-full  px-4 py-4">
        <section className="pt-1 grid grid-cols-2 items-center">
          <h1 className="text-xl font-bold text-white">
            {translations.booking.bookings}
            <small className="text-2xl font-semibold text-gray-600"> |</small>
            <small className="font-normal text-gray-600">
              {" "}
              {translations.booking.bookingManagement}
            </small>
          </h1>

          <div className="text-md text-white flex items-center justify-end space-x-1 ">
            <div className="rounded-full bg-[#5A189A] py-2 px-3">
              <Link to="/" className=" text-white  no-underline cursor-pointer">
                {translations.booking.dashboard}
              </Link>
              <span className="mx-1">/</span>
              <span className="text-green-300 ">
                {translations.booking.bookings}{" "}
              </span>
            </div>
          </div>
        </section>
        <div className="p-4 w-full bg-gray-800 shadow-xl rounded mt-5">
          {BookingContent}
        </div>
      </div>
    </Layout>
  );
}

export default Booking;
